(ns ^:no-doc frontend.version)

(defonce version "0.10.9")
